export default "/images/314c6f408f76c9906d988e22b0b09530.avif";